import { memo, useState, useEffect, FormEvent } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useForm, SubmitHandler } from "react-hook-form";

import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';

import { useGlobalConfigContext } from "../providers/GlobalConfig";
import { LoginRequired, AlreadyLogin } from "../providers/LoginUser";
import { LoginLayout } from "../layout/LoginLayout";
import {
  ProjectApi,
  ProjectAwsSesTokenApi,

  TicketModeEnum,
  GetProjectResponse,
  CreateAwsSesTokenRequest
} from "../openapi-generator/admin-api/";

type PageParam = {
  getProjectResponse: GetProjectResponse;
}
type PageForm = {
  projectId: string;
  data: CreateAwsSesTokenRequest;
}

export const AwsSesTokenCreatePage = memo(() => {

  const adminApiConfiguration = useGlobalConfigContext().adminApiConfiguration;
  const projectApi = new ProjectApi(adminApiConfiguration);
  const projectAwsSesTokenApi = new ProjectAwsSesTokenApi(adminApiConfiguration);

  const navigate = useNavigate();
  const urlParams = useParams<{ projectId: string }>();
  const [param, setParam] = useState<PageParam>();
  const { handleSubmit, register, reset, formState: { errors, isValid, isSubmitting } }
   = useForm<PageForm>();

  const onSubmit: SubmitHandler<PageForm> = async (form) => {
    console.log(form);
    var response = await projectAwsSesTokenApi.createAwsSesToken(form.projectId, form.data);
    console.log(response);
    navigate(`/project/${encodeURIComponent(form.projectId)}`);
  };

  useEffect(()=>{(async()=>{

    const getProjectResponse = await projectApi.getProject(urlParams.projectId || "");

    reset({
      projectId: getProjectResponse.data.projectId,
      data: {
        description: ""
      }
    });

    setParam({
      getProjectResponse: getProjectResponse.data
    });

  })();},[reset]);

  if (!!param) {

    return (
      <LoginLayout>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Form.Group className="mb-3" controlId="projectId">
            <Form.Label>projectId</Form.Label>
            <Form.Control { ...register('projectId', { required: true }) } disabled readOnly />
            { errors.projectId
              && <span>Please provide a valid projectId</span>
            }
          </Form.Group>
          <Form.Group className="mb-3" controlId="mode">
            <Form.Label>mode</Form.Label>
            <Form.Select { ...register('data.ticketMode', { required: true }) } >
              <option value="">Default select</option>
              { Object.entries(TicketModeEnum).map(([key,value]) => <option value={value}>{key}</option>) }
            </Form.Select>
            { errors.data && errors.data.ticketMode
              && <span>Please provide a valid ticketMode</span>
            }
          </Form.Group>
          <Form.Group className="mb-3" controlId="description">
            <Form.Label>description</Form.Label>
            <Form.Control { ...register('data.description', { required: false }) } />
            { errors.data && errors.data.description
              && <span>Please provide a valid description</span>
            }
          </Form.Group>


          <Button variant="primary" type="submit">Submit</Button>
        </Form>
      </LoginLayout>
    );
  } else {
    return <p>loading...</p>
  }
});